// The consent line under the sign-up form (there is no checkbox; meeting
// 2026-10-20). Saved with every lead (consentText) next to consent: true;
// sai's firestore.rules check only consent == true, but his lead email shows
// this line, so tell sai when it changes.
export const CONSENT_TEXT = 'We use this to set your demo up and to call you once. Nothing else.';

// What the visitor reads when sending or checking a code fails. From sai's
// phoneVerification.js and emailVerification.js (commit 2a7c405); kept free
// of the Firebase SDK so the screen can import it without loading Firebase.

const SMS_MESSAGES = {
  'auth/invalid-phone-number': 'That number doesn’t look right. Check it and try again.',
  'auth/missing-phone-number': 'Enter your mobile number.',
  'auth/too-many-requests': 'Too many attempts. Please wait a few minutes and try again.',
  'auth/quota-exceeded': 'We can’t send codes right now. Please try again later.',
  'auth/invalid-verification-code': 'That code isn’t right. Check the SMS and try again.',
  'auth/code-expired': 'That code has expired. Send a new one.',
  'auth/captcha-check-failed': 'We couldn’t complete the security check. Refresh the page and try again.',
  'auth/network-request-failed': 'No internet connection. Check it and try again.',
  'send-timeout': 'We couldn’t send the code. Check your connection and try again.',
  'auth/operation-not-allowed': 'We can’t send codes to this number right now. Please contact NirogGyan.',
};

export function verificationErrorMessage(error) {
  if (error && error.code === 'not-configured') {
    return 'Phone verification isn’t set up yet. Please contact NirogGyan.';
  }
  return SMS_MESSAGES[error && error.code] || 'Something went wrong. Please try again.';
}

const EMAIL_MESSAGES = {
  'bad-email': 'That does not look like an email address.',
  'bad-phone': 'That number doesn’t look right for this country. Check it and try again.',
  'no-consent': 'Something went wrong. Please try again.',
  'use-sms': 'This number is verified by SMS. Please try again.',
  cooldown: 'Please wait a few seconds before asking for another code.',
  'too-many': 'Too many codes asked for. Please wait an hour and try again.',
  'send-failed': 'We couldn’t send the email. Please try again in a minute.',
  'wrong-code': 'That code isn’t right. Check the email and try again.',
  expired: 'That code has expired. Send a new one.',
  locked: 'Too many wrong tries. Send a new code.',
  'no-code': 'That code has expired. Send a new one.',
};

// Firebase error codes the functions client raises on its own.
const CLIENT_MESSAGES = {
  'functions/unauthenticated': 'We couldn’t complete the security check. Refresh the page and try again.',
  'functions/unavailable': 'No internet connection. Check it and try again.',
  'functions/deadline-exceeded': 'That took too long. Check your connection and try again.',
};

export function emailErrorMessage(error) {
  if (error && error.code === 'not-configured') {
    return 'Email verification isn’t set up yet. Please contact NirogGyan.';
  }
  // The functions put a short reason in the message; the SDK appends the HTTP
  // status ("wrong-code [400]"), so only the first word is the reason.
  const reason = String((error && error.message) || '').split(' ')[0];
  const left = error && error.details && error.details.attemptsLeft;
  if (reason === 'wrong-code' && left > 0) {
    return `That code isn’t right. ${left} ${left === 1 ? 'try' : 'tries'} left.`;
  }
  return EMAIL_MESSAGES[reason] || CLIENT_MESSAGES[error && error.code] || 'Something went wrong. Please try again.';
}
